/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import CONST_IMAGE from 'constants/images';

import { SvgIconComponent, SvgIconStyles } from './components/SvgIconComponent';

// Use default Material UI icon names (https://material-ui.com/pt/components/material-icons)
const Close: React.FC<SvgIconStyles> = (props) => (
  <SvgIconComponent src={CONST_IMAGE.ICONS.CLOSE} {...props} />
);

export { Close };
export default Close;
